<c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>

<c11n-modal-dialog [modalId]="'backToLibraryWarningDialog'"
  [headingText]="'studentLearningQuiz.back_warning_title' | translate"
  [primaryButtonLabel]="'studentLearningQuiz.back_warning_confirm' | translate"
  [secondaryButtonLabel]="'studentLearningQuiz.back_warning_cancel' | translate" [variant]="'warning'"
  (primaryClick)="confirmGoBack()" #backWarningDialog>
  <div c11n-modal-dialog-body>
    <p class="c11n-text-md">{{ 'studentLearningQuiz.back_warning_body' | translate }}</p>
  </div>
</c11n-modal-dialog>

<div class="student-learning-quiz">
  <div class="quiz-container">
    <div class="quiz-header">
      <nav class="lesson-breadcrumbs" [attr.aria-label]="'studentLearningQuiz.breadcrumb_label' | translate">
        <button type="button" #backToLibraryBtn (click)="goBack()" c11n-link [variant]="'secondary-independent'">
          {{ 'studentLearningQuiz.back_to_learning_library' | translate }}
        </button>
        <ng-container *ngIf="displayLessonTitle">
          <span class="lesson-breadcrumb-separator" aria-hidden="true">/</span>
          <span class="lesson-breadcrumb-current">{{ displayLessonTitle }}</span>
        </ng-container>
      </nav>
    </div>

    <div class="quiz-content">
      <h1 class="quiz-title" [attr.aria-label]="lessonTitle">{{ lessonTitle }}</h1>

      <div class="quiz-info-row">
        <div class="info-badge">
          <span>{{ totalQuestions }} {{ 'studentLearningQuiz.questions_total' | translate }}</span>
        </div>

        <div class="info-badge">
          <img src="../../../../assets/icons/schedule.svg" alt="" aria-hidden="true">
          <span>{{ 'studentLearningQuiz.estimated_time' | translate }} {{ estimatedTime }} {{ 'studentLearningQuiz.min'
            | translate }}</span>
        </div>

        <div class="info-badge" *ngIf="toolsRequired">
          <span>{{ toolsRequired }} {{ 'studentLearningQuiz.required' | translate }}</span>
        </div>
      </div>

      <div class="quiz-description">
        <p class="c11n-text-md">
          <strong class="c11n-text-md-bold">{{ 'studentLearningQuiz.assess_understanding' | translate }}</strong> {{
          'studentLearningQuiz.core_concepts' | translate }}
        </p>
      </div>
    </div>
  </div>
  <app-learning-quiz-form #quizFormCmp (formSubmitted)="startQuiz($event)"></app-learning-quiz-form>
  <hr class="divider">
  <div class="quiz-container-second">
    <div class="quiz-actions">
      <c11n-button [ariaLabelText]="'studentLearningQuiz.refresh_on_lesson' | translate"
        [labelText]="'studentLearningQuiz.refresh_on_lesson' | translate" [variant]="'secondary'"
        [size]="isXsScreen ? 'small' : 'medium'" (clickEvent)="onBackToLesson()"></c11n-button>

      <c11n-button [ariaLabelText]="'studentLearningQuiz.start_assessment' | translate"
        [labelText]="'studentLearningQuiz.start_assessment' | translate" [variant]="'primary'"
        [size]="isXsScreen ? 'small' : 'medium'"
        (clickEvent)="onStartAssessment()"></c11n-button>
    </div>
  </div>
</div>